import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'nl2br',
  standalone: true,
})
export class Nl2BrPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, sanitizeBeforehand?: boolean): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const textParsed = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
    let result: string | null = textParsed;

    if (sanitizeBeforehand) {
      result = this.sanitizer.sanitize(SecurityContext.HTML, textParsed);
    }

    return result;
  }
}
